import { Box, Button, Stack } from "@mui/material";
import DirectUploadField from "components/Form/DirectUploadField";
import { RevivnApiForm } from "components/Form/RevivnApiForm";
import { SubmitAwareButton } from "components/Form/SubmitAwareButton";
import { useCallback, useRef, useState } from "react";
import { useFormAction, useLoaderData, useRouteLoaderData, useSubmit } from "react-router-dom";
import Webcam from "react-webcam";
import { Inventory } from "types/inventory";

export default function CaptureStep() {
  const webcamRef = useRef<Webcam>(null);
  const { activeDeviceId } = useLoaderData() as { activeDeviceId: string };
  const fileUploaderRef = useRef<{ addFile: (file: File) => void }>(null);
  const [hasCaptured, setHasCaptured] = useState(false);
  const { inventory } = useRouteLoaderData("receiving-inventory") as { inventory: Inventory };
  const submit = useSubmit();
  const action = useFormAction();

  const handleCaptureImage = useCallback(async () => {
    if (!webcamRef.current) return;
    const screenshot = webcamRef.current.getScreenshot();
    if (!screenshot) return;
    const res = await fetch(screenshot);
    const blob = await res.blob();
    const file: File = new File([blob], `${Date.now()}.jpg`, { type: "image/jpeg" });
    fileUploaderRef.current?.addFile(file);
    setHasCaptured(true);
  }, []);

  return (
    <RevivnApiForm
      initialValues={{ inventory_image: { inventory_id: inventory.id, images: [] } }}
      action={"/inventory_images"}
      method="POST"
      onSuccess={() => {
        // NOTE: submit() invokes the React Router action which
        // 1) navigates to ../review, and
        // 2) revalidates the page
        // tldr; RevivnApiForm does not interact with React Router's submit()
        submit(null, { action, method: "POST" });
      }}
    >
      <Box>
        <Webcam
          ref={webcamRef}
          forceScreenshotSourceSize
          screenshotFormat="image/jpeg"
          videoConstraints={{ deviceId: { exact: activeDeviceId } }}
          style={{ width: 480, aspectRatio: "1/1" }}
        />
      </Box>
      <Stack direction="row" spacing={1}>
        <Button onClick={handleCaptureImage}>Capture</Button>
        <SubmitAwareButton type="submit" disabled={!hasCaptured}>
          Next
        </SubmitAwareButton>
      </Stack>
      <DirectUploadField
        ref={fileUploaderRef}
        service="amazon_public"
        name="inventory_image[images]"
        keyPrefix={`inventories/${inventory.uuid}`}
        hideDropzone
      />
    </RevivnApiForm>
  );
}
